// @ts-nocheck
export const selectProducts = state => state.product.products;
export const selectProductDetails = state => state.product.productDetails;
export const selectProductChanges = state => state.product.productChanges;
export const selectProductChangesNext = state => state.product.productChangesNext;
